import React from 'react';

// Same span as the Form package's full-width fields, so these states line up with real inputs
const FULL_WIDTH = 'sm:col-span-2 w-full';

// Matches the Form Label styling used by PaginatedSelectorInputField
const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <label className="text-sm font-bold dark:text-blue-100 text-grey-1000">
    <div className="flex relative gap-2 items-center w-min whitespace-nowrap">{children}</div>
  </label>
);

export const LoadingSelectorField = ({ label }: { label: string }) => (
  <div className={`flex flex-col gap-2 ${FULL_WIDTH}`}>
    <FieldLabel>{label}</FieldLabel>
    <div className="h-10 rounded-md animate-pulse bg-grey-300 dark:bg-blue-700" />
  </div>
);

export const NoticeSelectorField = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className={`flex flex-col gap-2 ${FULL_WIDTH}`}>
    <FieldLabel>{label}</FieldLabel>
    <div className="px-3 py-2 text-sm border rounded-md text-amber-700 dark:text-amber-400 border-amber-300 dark:border-amber-600 bg-amber-50 dark:bg-amber-900/20">
      {children}
    </div>
  </div>
);

export const ReadOnlySelectorField = ({ label, value }: { label: string; value: string }) => (
  <div className={`flex flex-col gap-2 ${FULL_WIDTH}`}>
    <FieldLabel>{label}</FieldLabel>
    <div className="flex items-center px-3 py-2 rounded-md border hover:cursor-not-allowed h-[44px] dark:text-blue-100 text-grey-1000 bg-grey-100 border-grey-500 dark:bg-blue-900 dark:border-grey-600">
      {value}
    </div>
  </div>
);
